module.exports = __webpack_public_path__ + "img/max-file-content-signature-transfer.40ab219e.svg";